import { Link, NavLink } from "react-router-dom";
import { useAuth } from "../lib/auth";
import SideDrawer from "./SideDrawer";
import { Pumpkin } from "./Halloween";
import { LogIn, LogOut, User, Shield, ShoppingBag, Zap } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Header() {
  const { user, logout, loading } = useAuth();

  return (
    <header className="glass sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <SideDrawer />
          <Link to="/" data-testid="logo-home-link" className="flex items-center gap-2 group">
            <div className="w-11 h-11 rounded-full overflow-hidden diamond-glow bg-black grid place-items-center border-2 border-[#ff4500]">
              <img src="/logo.jpeg" alt="RECARGAS al Instante" className="w-full h-full object-cover rounded-full" />
            </div>
            <div className="leading-none hidden xs:block sm:block">
              <div className="font-display text-xl sm:text-2xl tracking-wider">RECARGAS</div>
              <div className="text-[9px] sm:text-[10px] tracking-[0.3em] text-[#ff4500] -mt-1">AL INSTANTE</div>
            </div>
            <Pumpkin className="w-8 h-8 sm:w-9 sm:h-9 pumpkin-glow shrink-0" />
          </Link>
        </div>

        <nav className="flex items-center gap-0.5 sm:gap-1 text-xs sm:text-sm overflow-x-auto">
          {user && (
            <NavLink to="/dashboard" className={({ isActive }) => `px-2 sm:px-3 py-2 rounded-md hover:text-[#ff4500] whitespace-nowrap ${isActive ? "text-[#ff4500]" : "text-white"}`} data-testid="nav-dashboard">Mis pedidos</NavLink>
          )}
          {user?.is_reseller && (
            <NavLink to="/revendedores" className={({ isActive }) => `hidden sm:block px-2 sm:px-3 py-2 rounded-md hover:text-[#ff4500] whitespace-nowrap ${isActive ? "text-[#ff4500]" : "text-white"}`} data-testid="nav-reseller">Revendedor</NavLink>
          )}
          {user?.is_admin && (
            <NavLink to="/admin" className={({ isActive }) => `px-2 sm:px-3 py-2 rounded-md hover:text-[#ff4500] whitespace-nowrap ${isActive ? "text-[#ff4500]" : "text-white"}`} data-testid="nav-admin">Admin</NavLink>
          )}
        </nav>

        <div className="flex items-center gap-2">
          {loading ? (
            <div className="h-9 w-24 bg-white/5 animate-pulse rounded-md" />
          ) : user ? (
            <div className="flex items-center gap-2">
              <Link to="/dashboard" data-testid="header-user-link" className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-md bg-white/5 hover:bg-white/10">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-6 h-6 rounded-full" />
                ) : (
                  <User className="w-4 h-4" />
                )}
                <span className="text-sm max-w-[140px] truncate">{user.name || user.email}</span>
                {user.is_admin && <Shield className="w-3.5 h-3.5 text-[#ff4500]" />}
              </Link>
              <button
                onClick={logout}
                data-testid="logout-btn"
                className="p-2 rounded-md hover:bg-white/10"
                aria-label="Cerrar sesión"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </div>
          ) : (
            <button
              onClick={startGoogleLogin}
              data-testid="login-btn"
              className="btn-primary flex items-center gap-2 px-4 py-2 rounded-md text-sm"
            >
              <LogIn className="w-4 h-4" /> Iniciar con Google
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
